module.exports = __webpack_public_path__ + "static/0024-3aab65115f34ffd83779e0d13803639d.png";